export const blackListedSurveysForCSVDownload = ['PACCOMOPPORTUNITY2020'];
